import { Component, Input } from '@angular/core';

import { SpinnerComponent } from '@core/user-interface-legacy';

@Component({
  selector: 'rt-uploading-attachments-item',
  templateUrl: './uploading-attachments-item.component.html',
  styleUrls: ['./uploading-attachments-item.component.less'],
  imports: [SpinnerComponent],
})
export class UploadingAttachmentsItemComponent {
  @Input() public fileData: { file: File };
}
